import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { VueMasonryPlugin } from 'vue-masonry'
import infiniteScroll from 'vue-infinite-scroll'
import VueFlashMessage from 'vue-flash-message'
import vSelect from 'vue-select'
import VModal from 'vue-js-modal'
import moment from 'moment'
import VueGtag from 'vue-gtag'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import VueMatomo from 'vue-matomo'

import App from './App.vue'
import router from './router'
import store from './store'
import '@/axiosConfig'

import 'swiper/dist/css/swiper.css'
import 'vue-select/dist/vue-select.css'
import 'vue-flash-message/dist/vue-flash-message.min.css'
import 'tailwindcss/tailwind.css'
moment.locale('fr')

Vue.use(VueAwesomeSwiper)
Vue.use(VueMasonryPlugin)
Vue.use(VueFlashMessage, {
  messageOptions: {
    timeout: 3500,
    important: false
  }
})
Vue.use(infiniteScroll)
Vue.use(VModal)
Vue.component('v-select', vSelect)
Vue.config.productionTip = false

Vue.filter('pluralize', (word, amount) => (amount > 1 ? word + 's' : word))
Vue.filter('capitalize', (word) => word.charAt(0).toUpperCase() + word.slice(1))

Vue.use(
  VueGtag,
  {
    config: { id: 'UA-48177265-6' }
  },
  router
)

Vue.use(VueMatomo, {
  host: "https://acta.matomo.cloud/",
  siteId: 4,
  requireConsent: false,
  trackerFileName: "matomo",
  router: router,
  enableLinkTracking: true,
  trackInitialView: true,
  disableCookies: false,
})

// if (process.env.NODE_ENV !== 'development') {
//   Sentry.init({
//     Vue,
//     dsn: 'https://d64579dd82d84662a2c774b829d8bf0c@sentry.acta-ds.fr/9',
//     integrations: [
//       new Integrations.BrowserTracing({
//         routingInstrumentation: Sentry.vueRouterInstrumentation(router)
//       })
//     ],
//     environment: process.env.NODE_ENV,
//     attachStacktrace: true,
//     trackComponents: true,
//     tracesSampleRate: 1.0,
//     beforeBreadcrumb (breadcrumb, hint) {
//       switch (breadcrumb.category) {
//         case 'xhr':
//           if (hint.input != null) breadcrumb.data.body = hint.input
//           if (hint.xhr.statusText !== 'OK') {
//             breadcrumb.data.response = hint.xhr.response
//           }
//       }
//       return breadcrumb
//     }
//   })
// }

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
